import {
  NumericTypeInput,
  NumericTypeProps,
} from '@/components/GeneralInputs/NumericTypeInput';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { FORMATS } from '@moneyforward/ap-frontend-components/dist/es/atoms/Form/Input/InputNumber';
import { memo, useMemo } from 'react';

type Props<TFieldValues extends PaymentRequestForm> = Omit<
  NumericTypeProps<TFieldValues>,
  'inputProps'
> & { property: TransactionProperty };

const InnerNumericTypeCell = <TFieldValues extends PaymentRequestForm>({
  control,
  inputId,
  property,
  name,
  rules,
}: Props<TFieldValues>) => {
  const inputProps = useMemo(() => {
    return {
      format: FORMATS.UNIT_WITH_EMPTY,
      stringMode: true,
    };
  }, []);

  return (
    <NumericTypeInput<TFieldValues>
      control={control}
      inputId={inputId}
      name={name}
      placeholder={property.placeholder}
      rules={rules}
      inputProps={inputProps}
    />
  );
};
InnerNumericTypeCell.displayName = 'NumericTypeCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const NumericTypeCell = memo(
  InnerNumericTypeCell
) as typeof InnerNumericTypeCell;
NumericTypeCell.displayName = 'NumericTypeCell';
